import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    baseUrl: String,
    updateNow: { type: Boolean, default: false }
  }

  connect() {
    if (this.updateNowValue) {
      this.update();
    }
  }

  async update() {
    const originalFrame = document.getElementById('companies_list');
    if (!originalFrame) {
      return;
    }

    try {
      // Get current URL and preserve all its parameters
      const currentUrl = new URL(window.location.href);
      const searchParams = currentUrl.searchParams;

      // Create a new URL using the base URL provided by Rails
      const newUrl = new URL(this.baseUrlValue, window.location.origin);

      // Copy all parameters from the current URL
      for (const [key, value] of searchParams.entries()) {
        newUrl.searchParams.set(key, value);
      }

      // Fetch new content with all parameters preserved
      const response = await fetch(newUrl.toString());
      const html = await response.text();

      // Extract frame content using DOM parser
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newFrame = doc.getElementById('companies_list');

      if (newFrame) {
        // Update the original frame content
        originalFrame.innerHTML = newFrame.innerHTML;
      }
    } catch (error) {
      console.error('Error updating companies list:', error);
      // On error, keep the original content
    }
  }
}
